import { render, staticRenderFns } from "./AbcFileUploader.vue?vue&type=template&id=23824759&scoped=true&"
import script from "./AbcFileUploader.vue?vue&type=script&lang=js&"
export * from "./AbcFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./AbcFileUploader.vue?vue&type=style&index=0&id=23824759&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23824759",
  null
  
)

export default component.exports